var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCartonBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 133 130",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "--404",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "404---logged-out",
    transform: "translate(-655.000000, -268.000000)",
    stroke: "#49494A",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(391.411707, 271.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10-Copy",
    transform: "translate(330.088293, 62.000000) scale(-1, 1) rotate(-180.000000) translate(-330.088293, -62.000000) translate(266.588293, 0.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 63.5,
    y1: 76,
    x2: 63.5,
    y2: 0,
    id: "path202",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path204",
    strokeLinejoin: "round",
    points: "-8.88588817e-14 99.804878 63.5 124 127 99.804878 127 24.195122 63.5 0 -8.88588817e-14 24.195122"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "path206",
    strokeLinejoin: "round",
    points: "127 99 63.5 75 -7.96740307e-14 99"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 95,
    y1: 87,
    x2: 31,
    y2: 111,
    id: "path208",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path210",
    points: "118 62.2394624 91.3113962 53 86 68.7605376 112.688906 78"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "path212",
    points: "104.50867 49.2059548 110 47.5631344 104.519343 29 73 38.4377854 78.480657 57 82.5756742 55.773557"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "path214",
    strokeLinecap: "round",
    points: "21 54 14.999985 63 9 59.0921477"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.5,
    y1: 60,
    x2: 15.5,
    y2: 45,
    id: "path216",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "path218",
    strokeLinecap: "round",
    points: "40 47 33.9998498 56 28 52.0953747"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 33.5,
    y1: 54,
    x2: 33.5,
    y2: 39,
    id: "path220",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 36,
    x2: 39,
    y2: 24,
    id: "path222",
    strokeLinecap: "round"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartonBox);
export default __webpack_public_path__ + "static/media/carton-box.2ff8f18203a53bd52b2b36d0fcb80266.svg";
export { ForwardRef as ReactComponent };